export default __webpack_public_path__ + "static/media/new_mision.b68ac6f8.jpg";